import React from "react";
import {Badge, Button, Card, Col, Form, ProgressBar, Row} from "react-bootstrap";
export default function IdentityPreview({
                                            identityPatient = {}, setIdentityPatient, applyIdentity
                                        }) {
    const updateField = (field, value) => {
        setIdentityPatient({
            ...(identityPatient || {}), [field]: value
        });
    };
    return (<Card className="mt-3 shadow-sm">

        <Card.Body>
            {/* ===========================
                        OCR STATUS
                ============================ */}


            <div className="mb-3">


                <Badge bg="success">

                    OCR Ready

                </Badge>


                <div className="mt-2">


                    <small>

                        Extraction Confidence

                    </small>


                    <ProgressBar

                        now={identityPatient.confidence || 0}

                        label={`${identityPatient.confidence || 0}%`}

                    />


                </div>


            </div>


            <Row>


                {/* NAME */}

                <Col md={6}>


                    <Form.Group className="mb-3">


                        <Form.Label>

                            Patient Name

                        </Form.Label>


                        <Form.Control

                            value={identityPatient.patient || ""}


                            onChange={(e) => updateField("patient", e.target.value)}

                        />


                    </Form.Group>


                </Col>


                {/* DOB */}

                <Col md={6}>


                    <Form.Group className="mb-3">


                        <Form.Label>

                            Date of Birth

                        </Form.Label>


                        <Form.Control

                            type="date"

                            value={identityPatient.dob || ""}


                            onChange={(e) => updateField("dob", e.target.value)}


                        />


                    </Form.Group>


                </Col>


                {/* GENDER */}

                <Col md={6}>


                    <Form.Group className="mb-3">


                        <Form.Label>

                            Gender

                        </Form.Label>


                        <Form.Select


                            value={identityPatient.gender || ""}


                            onChange={(e) => updateField("gender", e.target.value)}

                        >

                            <option value="">
                                Select
                            </option>

                            <option value="Male">
                                Male
                            </option>


                            <option value="Female">
                                Female
                            </option>


                            <option value="Other">
                                Other
                            </option>


                        </Form.Select>


                    </Form.Group>


                </Col>


                {/* DOCUMENT NUMBER */}

                <Col md={6}>


                    <Form.Group className="mb-3">


                        <Form.Label>

                            Document Number

                        </Form.Label>


                        <Form.Control


                            value={identityPatient.abha || ""}


                            onChange={(e) => updateField("abha", e.target.value)}


                        />


                    </Form.Group>


                </Col>


                {/* ADDRESS */}

                <Col md={6}>
                    <Form.Label>

                        Mobile

                    </Form.Label>
                    <Form.Control
                        value={identityPatient.mobile || ""}
                        onChange={(e) => setIdentityPatient({
                            ...(identityPatient || {}), mobile: e.target.value
                        })}
                    />
                </Col>
                <Col md={6}>
                    <Form.Group>


                        <Form.Label>

                            Address

                        </Form.Label>


                        <Form.Control

                            as="textarea"

                            rows={5}


                            value={identityPatient.address1 || ""}


                            onChange={(e) => updateField("address1", e.target.value)}


                        />


                    </Form.Group>


                </Col>


            </Row>


            <Button

                variant="success"

                size="lg"

                className="w-100 mt-4"


                onClick={applyIdentity}


            >

                ✅ Apply To Patient Summary


            </Button>


        </Card.Body>


    </Card>);
}